module.exports = __webpack_public_path__ + "img/todayVisitor.3289a8ba.png";